var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AdminTable', {
    attrs: {
      "users": _vm.localUsers,
      "headers": _vm.headersClone,
      "options": _vm.options
    },
    on: {
      "handleDelete": _vm.handleDelete,
      "handleUpdate": _vm.handleUpdate
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7329f926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/AdminTableContainer.vue
// module id = vXyZ
// module chunks = 2